/* KissMyCans "Night Ride" — homepage behaviour.
   No dependencies. The 3D viewer and meshes load on demand, only once a can is picked. */
(function () {
  var SW = { black:'#15171b', white:'#e9e6df', red:'#c22118', blue:'#1c47ca',
             grey:'#6f7783', gray:'#6f7783', silver:'#b9c0ca', green:'#1f7a45',
             orange:'#e0651c', yellow:'#e5b528', pink:'#d9528f', purple:'#6c3fc4' };

  /* Colour options are rarely bare words: "Ducati Red", "Ice White", "Black - Original".
     Match on the colour word found anywhere in the name, longest first so
     "light blue" doesn't win over "blue" by accident. */
  var SW_KEYS = Object.keys(SW).sort(function (a, b) { return b.length - a.length; });
  function swatchColour(name) {
    var k = (name || '').toLowerCase().replace(/[^a-z]/g, '');
    if (SW[k]) return SW[k];
    for (var i = 0; i < SW_KEYS.length; i++) if (k.indexOf(SW_KEYS[i]) !== -1) return SW[SW_KEYS[i]];
    return '#7d8795';
  }

  function load(src) {
    return new Promise(function (res, rej) {
      if (!src) return rej();
      if (document.querySelector('script[data-kmc-src="' + src + '"]')) return res();
      var s = document.createElement('script');
      s.src = src; s.async = true;
      s.setAttribute('data-kmc-src', src);
      s.onload = function () { res(); };
      s.onerror = function () { rej(); };
      document.head.appendChild(s);
    });
  }

  /* ---------- toast ---------- */
  var toastEl = null;
  function toast(msg) {
    if (!toastEl) {
      var host = document.createElement('div');
      host.className = 'kmc-nr';
      toastEl = document.createElement('div');
      toastEl.className = 'toast kmc-toast';
      toastEl.setAttribute('role', 'status');
      host.appendChild(toastEl);
      document.body.appendChild(host);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('on');
    clearTimeout(toastEl._h);
    toastEl._h = setTimeout(function () { toastEl.classList.remove('on'); }, 2200);
  }

  /* ---------- cart ---------- */
  var lastCart = null;
  /* Refreshes can overlap when someone taps Add fast. Only the newest one is allowed to paint,
     so an older, slower response can never put a stale count back in the header. */
  var refreshSeq = 0;
  function refreshCartCount() {
    var mine = ++refreshSeq;
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (mine !== refreshSeq) return lastCart || cart;
        var n = cart.item_count;
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble > span:first-child, [data-cart-count]')
          .forEach(function (el) { el.textContent = n; });
        var bubble = document.querySelector('.cart-count-bubble');
        if (bubble) bubble.hidden = false;
        else {
          /* Dawn only renders the bubble when the cart has items — ask it to re-render the icon */
          var icon = document.getElementById('cart-icon-bubble');
          if (icon) {
            fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?section_id=cart-icon-bubble' : '/?section_id=cart-icon-bubble')
              .then(function (r) { return r.text(); })
              .then(function (html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var fresh = doc.getElementById('shopify-section-cart-icon-bubble');
                /* header.liquid inlines this markup instead of rendering it as a section, so
                   #shopify-section-cart-icon-bubble is never in the page and the badge never
                   appeared until a full page load. Fall back to the cart link itself, whose
                   contents are exactly what the section renders. */
                var host = document.getElementById('shopify-section-cart-icon-bubble')
                        || document.getElementById('cart-icon-bubble');
                if (fresh && host) host.innerHTML = fresh.innerHTML;
              }).catch(function () {});
          }
        }
        lastCart = cart;
        document.dispatchEvent(new CustomEvent('kmc:cart', { detail: { cart: cart } }));
        return cart;
      });
  }

  /* Cart writes go one at a time. Shopify can drop one of two adds that land together, and
     now that the button no longer locks, two quick taps would do exactly that. */
  var cartQueue = Promise.resolve();
  function enqueue(fn) {
    var p = cartQueue.then(fn);
    cartQueue = p.catch(function () {});
    return p;
  }

  function addToCart(id, qty) {
    return enqueue(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw j; return j; });
      });
    }).then(function (j) {
      return refreshCartCount().then(function () { return j; });
    });
  }

  /* ---------- fly to cart ----------
     Whatever was added flies up in an arc to the header cart icon, which bumps when it lands.
     When the gift snippet (snippets/kmc-free-gift.liquid) drops the Free Gift Pack in, it
     announces the new cart on 'kmc:cart'; the gift is spotted there and flies up second, from
     the same spot, with a FREE tag. After one holder lands, a pill under the icon says how many
     more get the gift. Reduced-motion users get no flight, just the toast and the pill. */
  var GIFT_HANDLE = 'add-on-pack', HOLDER_TYPE = 'Can Holder', GIFT_NEED = 2, FLY_MS = 750;
  var reduceMotion = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var canFly = !reduceMotion && !!Element.prototype.animate;
  var flyCss = false, pillEl = null, hadGift = null, lastFrom = null, lastFlight = Promise.resolve();

  function flyStyles() {
    if (flyCss) return;
    flyCss = true;
    var s = document.createElement('style');
    s.textContent =
      '.kmc-fly{position:fixed;left:0;top:0;z-index:2147483000;pointer-events:none;will-change:transform,opacity}' +
      '.kmc-fly img{display:block;width:100%;height:100%;object-fit:cover;border-radius:14px;background:#15171c;box-shadow:0 10px 30px rgba(0,0,0,.5)}' +
      '.kmc-fly-tag{position:absolute;top:-9px;right:-9px;background:#1f9d55;color:#fff;font:800 12px/1 "Barlow Condensed",Arial,sans-serif;letter-spacing:.06em;padding:6px 8px;border-radius:999px}' +
      '@keyframes kmcBump{0%{transform:scale(1)}35%{transform:scale(1.3)}65%{transform:scale(.9)}100%{transform:scale(1)}}' +
      '.kmc-bump{animation:kmcBump .45s ease-out}' +
      '.kmc-pill{position:fixed;z-index:2147483001;pointer-events:none;background:#e8342a;color:#fff;font:700 13px/1.2 Barlow,Arial,sans-serif;padding:9px 13px;border-radius:999px;box-shadow:0 6px 18px rgba(0,0,0,.45);white-space:nowrap;opacity:0;transform:translateY(-6px);transition:opacity .2s,transform .2s}' +
      '.kmc-pill.on{opacity:1;transform:none}' +
      '.kmc-pill.is-won{background:#1f9d55}' +
      '.kmc-pill:before{content:"";position:absolute;top:-5px;right:var(--arrow,16px);width:10px;height:10px;background:inherit;transform:rotate(45deg)}' +
      '.kmc-pill.is-up:before{top:auto;bottom:-5px}';
    document.head.appendChild(s);
  }

  function inView(r) { return r && r.width && r.bottom > 0 && r.top < window.innerHeight; }
  function rectOf(el) {
    if (!el) return null;
    var r = el.getBoundingClientRect();
    return inView(r) ? r : null;
  }

  /* The header icon. If it is ever off screen, the phone checkout bar is the next best thing. */
  function cartTarget() {
    var icon = document.getElementById('cart-icon-bubble');
    if (rectOf(icon)) return icon;
    var bar = document.querySelector('.kmc-sticky');
    if (bar && !bar.hidden && rectOf(bar)) return bar;
    return icon;
  }

  function bump(el) {
    if (!el || !canFly) return;
    flyStyles();
    el.classList.remove('kmc-bump');
    void el.offsetWidth;
    el.classList.add('kmc-bump');
    clearTimeout(el._kmcBump);
    el._kmcBump = setTimeout(function () { el.classList.remove('kmc-bump'); }, 500);
  }

  /* Resolves when it lands (straight away when there is nothing to fly). */
  function fly(src, from, opts) {
    opts = opts || {};
    return new Promise(function (resolve) {
      var to = cartTarget();
      var tr = to && to.getBoundingClientRect();
      if (!canFly || !src || !from || !tr || !tr.width) return resolve();
      flyStyles();

      var size = Math.round(Math.max(56, Math.min(130, from.width * 0.55, from.height * 0.55)));
      var el = document.createElement('div');
      el.className = 'kmc-fly';
      el.style.width = el.style.height = size + 'px';
      var img = new Image();
      img.alt = '';
      img.src = src;
      el.appendChild(img);
      if (opts.tag) {
        var t = document.createElement('span');
        t.className = 'kmc-fly-tag';
        t.textContent = opts.tag;
        el.appendChild(t);
      }
      document.body.appendChild(el);

      /* Quadratic curve: rises from the product first, then swings across into the icon. */
      var x0 = from.left + from.width / 2 - size / 2, y0 = from.top + from.height / 2 - size / 2;
      var x2 = tr.left + tr.width / 2 - size / 2,     y2 = tr.top + tr.height / 2 - size / 2;
      var cx = x0 + (x2 - x0) * 0.15,                 cy = Math.max(-size / 2, y2 + (y0 - y2) * 0.12);
      var frames = [], N = 24;
      for (var i = 0; i <= N; i++) {
        var p = i / N;
        var k = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;   /* ease in-out */
        var u = 1 - k;
        var x = u * u * x0 + 2 * u * k * cx + k * k * x2;
        var y = u * u * y0 + 2 * u * k * cy + k * k * y2;
        var sc = i === 0 ? 1 : Math.max(0.18, 1 - 0.82 * k);
        frames.push({ transform: 'translate(' + x + 'px,' + y + 'px) scale(' + sc + ')',
                      opacity: i === N ? 0.3 : 1, offset: p });
      }
      var done = false;
      var finish = function () {
        if (done) return;
        done = true;
        el.remove();
        bump(to);
        resolve();
      };
      var a = el.animate(frames, { duration: opts.ms || FLY_MS, easing: 'linear', fill: 'forwards' });
      a.onfinish = finish;
      a.oncancel = finish;
      setTimeout(finish, (opts.ms || FLY_MS) + 400);   /* never leave a ghost on screen */
    });
  }

  function flyToCart(src, from) {
    if (hadGift === null) hadGift = !!giftLineIn(lastCart);
    lastFrom = from;
    lastFlight = fly(src, from);
    return lastFlight;
  }

  function holdersIn(cart) {
    var n = 0;
    ((cart && cart.items) || []).forEach(function (i) {
      if (i.product_type === HOLDER_TYPE && i.handle !== GIFT_HANDLE) n += i.quantity;
    });
    return n;
  }
  function giftLineIn(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) if (items[i].handle === GIFT_HANDLE) return items[i];
    return null;
  }

  function pill(text, won) {
    var to = cartTarget();
    var r = to && to.getBoundingClientRect();
    if (!r || !r.width) return;
    flyStyles();
    if (!pillEl) {
      pillEl = document.createElement('div');
      pillEl.className = 'kmc-pill';
      pillEl.setAttribute('role', 'status');
      document.body.appendChild(pillEl);
    }
    pillEl.textContent = text;
    pillEl.classList.toggle('is-won', !!won);
    var up = r.top > window.innerHeight / 2;              /* the bottom checkout bar: sit above it */
    pillEl.classList.toggle('is-up', up);
    var right = Math.max(8, window.innerWidth - r.right - 4);
    pillEl.style.left = 'auto';
    pillEl.style.right = right + 'px';
    if (up) { pillEl.style.top = 'auto'; pillEl.style.bottom = (window.innerHeight - r.top + 10) + 'px'; }
    else    { pillEl.style.bottom = 'auto'; pillEl.style.top = (r.bottom + 10) + 'px'; }
    var arrow = (window.innerWidth - right) - (r.left + r.width / 2) - 5;
    pillEl.style.setProperty('--arrow', Math.max(10, arrow) + 'px');
    pillEl.classList.remove('on');
    clearTimeout(pillEl._h);
    /* The hide timer starts only once it is actually shown: a phone that switches app mid-add
       pauses animation frames, and a timer started earlier would fire first and leave it stuck. */
    requestAnimationFrame(function () {
      pillEl.classList.add('on');
      clearTimeout(pillEl._h);
      pillEl._h = setTimeout(function () { pillEl.classList.remove('on'); }, won ? 2800 : 3800);
    });
  }

  /* After a holder lands: say how many more get the gift. Silent once the gift is in or earned. */
  function nudge() {
    var cart = lastCart;
    if (!cart || giftLineIn(cart)) return;
    var n = holdersIn(cart);
    if (!n || n >= GIFT_NEED) return;
    var left = GIFT_NEED - n;
    pill(left === 1 ? 'Add 1 more holder, get the gift pack and shipping free'
                    : 'Add ' + left + ' more holders, get the gift pack and shipping free');
  }

  document.addEventListener('kmc:cart', function (e) {
    var cart = e.detail && e.detail.cart;
    if (!cart || !cart.items) return;
    lastCart = cart;
    var g = giftLineIn(cart);
    if (hadGift === false && g) {
      var src = g.image || (g.featured_image && g.featured_image.url);
      lastFlight = lastFlight
        .then(function () { return fly(src, lastFrom, { tag: 'FREE', ms: 800 }); })
        .then(function () { pill('Free gift pack added', true); });
    }
    hadGift = !!g;
  });

  /* Button says "Added ✓" for a moment but stays live, so the next tap works straight away. */
  function flashAdded(btn, restore) {
    btn.textContent = 'Added ✓';
    clearTimeout(btn._kmcT);
    btn._kmcT = setTimeout(restore, 900);
  }

  /* ---------- quick add buttons (gear cards, extras) ---------- */
  function bindQuickAdd(scope) {
    scope.querySelectorAll('[data-kmc-add]').forEach(function (b) {
      if (b.dataset.kmcBound) return;
      b.dataset.kmcBound = '1';
      var label = b.textContent;
      b.addEventListener('click', function (e) {
        var id = b.getAttribute('data-kmc-add');
        if (!id) return;                       /* no variant: it's a plain link, let it through */
        e.preventDefault();
        var title = b.getAttribute('data-kmc-title') || 'item';
        var card = b.closest('article, li, [class*="card"], [class*="item"]') || b.parentElement;
        var img = card && card.querySelector('img');
        var from = rectOf(img) || b.getBoundingClientRect();
        flashAdded(b, function () { b.textContent = label; });
        var landed = flyToCart(img && (img.currentSrc || img.src), from);
        addToCart(id, 1).then(function () {
          if (!canFly) toast('Added: ' + title);
          return landed;
        }).then(nudge).catch(function (err) {
          clearTimeout(b._kmcT);
          b.textContent = label;
          toast((err && err.description) ? err.description : 'Could not add that to the cart.');
        });
      });
    });
  }

  /* ---------- hero video ---------- */
  function bindHero(scope) {
    var v = scope.querySelector('.kmc-hero video.bg');
    if (!v || v.dataset.kmcBound) return;
    v.dataset.kmcBound = '1';
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var show = function () { v.classList.add('ready'); };
    if (v.readyState >= 3) show(); else v.addEventListener('canplay', show, { once: true });
    v.play().catch(function () {});
  }

  /* ---------- reel (click to play) ---------- */
  function bindReel(scope) {
    var fig = scope.querySelector('.reel');
    if (!fig || fig.dataset.kmcBound) return;
    var vid = fig.querySelector('video'), btn = fig.querySelector('.play');
    if (!vid || !btn) return;
    fig.dataset.kmcBound = '1';
    btn.addEventListener('click', function () {
      if (!vid.querySelector('source') && vid.dataset.src) {
        var s = document.createElement('source');
        s.src = vid.dataset.src;
        if (vid.dataset.type) s.type = vid.dataset.type;
        vid.appendChild(s);
        vid.setAttribute('controls', '');
        vid.load();
      }
      if (!vid.querySelector('source') && !vid.src) { toast('No clip uploaded yet'); return; }
      var mark = function () { fig.classList.add('playing'); };
      var go = function () {
        vid.play().then(mark).catch(function () {
          vid.muted = true;
          vid.play().then(mark).catch(function () { toast('Your browser blocked the video'); });
        });
      };
      vid.muted = false;
      if (vid.readyState >= 2) go(); else vid.addEventListener('loadeddata', go, { once: true });
      vid.addEventListener('error', function () { toast("This browser can't play the clip"); }, { once: true });
    });
  }

  /* ---------- the size picker + 3D configurator ---------- */
  function initPicker(root) {
    if (root.dataset.kmcReady) return;
    var dataEl = root.querySelector('[data-kmc-data]');
    if (!dataEl) return;
    root.dataset.kmcReady = '1';

    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var form    = root.querySelector('[data-kmc-form]'),
        tiles   = [].slice.call(root.querySelectorAll('.tile')),
        nameEl  = root.querySelector('[data-kmc-name]'),
        fitEl   = root.querySelector('[data-kmc-fit]'),
        priceEl = root.querySelector('[data-kmc-price]'),
        colWrap = root.querySelector('[data-kmc-colours]'),
        colName = root.querySelector('[data-kmc-colname]'),
        swWrap  = root.querySelector('[data-kmc-swatches]'),
        addBtn  = root.querySelector('[data-kmc-add-btn]'),
        vidInput= root.querySelector('[data-kmc-vid]'),
        errEl   = root.querySelector('[data-kmc-err]'),
        stage   = root.querySelector('[data-kmc-stage]'),
        canvas  = root.querySelector('[data-kmc-canvas]'),
        fallback= root.querySelector('[data-kmc-fallback]'),
        moreEl  = root.querySelector('[data-kmc-more]');

    var current = null, variant = null, viewer = null, viewerTried = false;

    /* Wrong-region size guard. The commonest support problem is a US or Canadian buyer taking the
       500ml holder, because Monster ships there in a 473ml / 16oz can that the 500ml part will not
       hold. Warn on selection and offer the swap in one click. Country comes from the shopper's
       chosen market, which can be wrong, so the tiles also carry a permanent region badge and the
       warning never blocks the sale — it informs, they decide. */
    var NA = { US: 1, CA: 1 };
    var warnEl  = root.querySelector('[data-kmc-fitwarn]'),
        warnTxt = root.querySelector('[data-kmc-fitwarn-txt]'),
        swapBtn = root.querySelector('[data-kmc-fitswap]'),
        country = (root.dataset.country || '').toUpperCase();

    function handleForRegion(reg) {
      for (var h in DATA) if (DATA[h].region === reg) return h;
      return null;
    }
    function paintFitWarning() {
      if (!warnEl || !warnTxt) return;
      var reg = current && current.region;
      if (!reg) { warnEl.hidden = true; return; }

      /* Both Monster sizes always say which can they are for. It only turns into a red warning
         when the shopper's market and the product disagree — an American with the store set to
         Ireland would otherwise see nothing, which is how the wrong size gets ordered. */
      var buyerIsNA = !!NA[country],
          mismatch = country ? ((buyerIsNA && reg === 'row') || (!buyerIsNA && reg === 'na')) : false,
          want = handleForRegion(reg === 'row' ? 'na' : 'row'),
          msg, label;

      if (mismatch) {
        msg = (reg === 'row' ? root.dataset.warnNa : root.dataset.warnRow) || '';
        label = (root.dataset.warnSwap || 'Switch to the one that fits');
        if (want && DATA[want]) label += ': ' + DATA[want].title;
        warnEl.className = 'fitwarn';
      } else {
        msg = (reg === 'row' ? root.dataset.noteRow : root.dataset.noteNa) || '';
        label = (root.dataset.noteSwap || 'Switch to the');
        if (want && DATA[want]) label += ' ' + DATA[want].title;
        warnEl.className = 'fitwarn is-note';
      }
      if (!msg) { warnEl.hidden = true; return; }

      warnTxt.textContent = msg;
      if (swapBtn) {
        if (want && DATA[want]) {
          swapBtn.textContent = label;
          swapBtn.hidden = false;
          swapBtn.onclick = function () {
            var t = root.querySelector('.tile[data-handle="' + want + '"]');
            if (t) { t.click(); t.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
          };
        } else {
          swapBtn.hidden = true;
        }
      }
      warnEl.hidden = false;
    }

    /* Free-gift nudge. The offer itself is run by the gift app, so this never claims the gift
       has been applied unless the cart actually contains a zero-priced line: everything else it
       says is a restatement of the offer, which stays true whatever the app does. */
    var giftEl  = root.querySelector('[data-kmc-gift]'),
        giftTxt = root.querySelector('[data-kmc-gift-txt]'),
        giftNeed = parseInt(root.dataset.giftThreshold, 10) || 2,
        giftOn  = root.dataset.gift === 'true';

    function holdersInCart(cart) {
      var n = 0;
      (cart.items || []).forEach(function (it) {
        if (DATA[it.handle]) n += it.quantity;
      });
      return n;
    }
    function giftInCart(cart) {
      return (cart.items || []).some(function (it) {
        return it.price === 0 && it.quantity > 0;
      });
    }
    function paintGift(cart) {
      if (!giftOn || !giftEl || !giftTxt || !cart) return;
      var n = holdersInCart(cart), got = giftInCart(cart);
      if (got) {
        giftTxt.textContent = 'Free gift pack added to your cart.';
        giftEl.className = 'giftnudge is-won';
        giftEl.hidden = false;
      } else if (n > 0 && n < giftNeed) {
        var left = giftNeed - n;
        giftTxt.textContent = left === 1
          ? 'One more holder and the gift pack and shipping are free.'
          : left + ' more holders and the gift pack and shipping are free.';
        giftEl.className = 'giftnudge';
        giftEl.hidden = false;
      } else if (n >= giftNeed) {
        giftTxt.textContent = n + ' holders in your cart, so the gift pack is on us.';
        giftEl.className = 'giftnudge is-won';
        giftEl.hidden = false;
      } else {
        giftEl.hidden = true;
      }
    }
    document.addEventListener('kmc:cart', function (e) { paintGift(e.detail.cart); });
    if (giftOn && giftEl) {
      if (lastCart) paintGift(lastCart);
      else refreshCartCount().catch(function () {});
    }

    function setErr(msg) {
      if (!errEl) return;
      errEl.textContent = msg || '';
      errEl.hidden = !msg;
    }

    function pickVariant(colour) {
      if (!current) return null;
      var vs = current.variants, i;
      if (colour) {                                  /* honour the colour, sold out or not */
        for (i = 0; i < vs.length; i++) if ((vs[i].colour || '') === colour) return vs[i];
        return null;
      }
      for (i = 0; i < vs.length; i++) if (vs[i].available) return vs[i];
      return vs[0] || null;
    }

    function paintPrice() {
      if (!variant || !priceEl) return;
      priceEl.innerHTML = '';
      priceEl.appendChild(document.createTextNode(variant.price || ''));
      if (variant.compare) {
        var s = document.createElement('s');
        s.textContent = variant.compare;
        priceEl.appendChild(s);
      }
      priceEl.hidden = false;
    }

    function selectVariant(v) {
      variant = v;
      clearTimeout(addBtn._kmcT);
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'Sold out'; return; }
      if (vidInput) vidInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (colName) colName.textContent = v.colour || '';
      paintPrice();
      if (viewer && v.colour) viewer.colour(v.colour);
      setErr('');
      document.dispatchEvent(new CustomEvent('kmc:selected'));
    }

    function restoreAddBtn() {
      if (variant) addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }

    function buildSwatches() {
      if (!swWrap) return;
      swWrap.innerHTML = '';
      var seen = {}, any = false;
      current.variants.forEach(function (v) {
        var c = v.colour;
        if (!c || seen[c]) return;
        seen[c] = true; any = true;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'swatch';
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', (variant && (variant.colour || '') === c) ? 'true' : 'false');
        b.setAttribute('aria-label', c + (v.available ? '' : ' (sold out)'));
        b.title = c + (v.available ? '' : ' (sold out)');
        b.style.setProperty('--c', swatchColour(c));
        if (!v.available) b.classList.add('is-out');
        b.addEventListener('click', function () {
          [].forEach.call(swWrap.children, function (x) { x.setAttribute('aria-checked', 'false'); });
          b.setAttribute('aria-checked', 'true');
          selectVariant(pickVariant(c) || v);
        });
        swWrap.appendChild(b);
      });
      if (colWrap) colWrap.hidden = !any;
    }

    /* The viewer code (~9 KB) loads once, on the first tile tap. Meshes live in one file per
       model (60-100 KB each) and load only when that model is picked, into the shared
       window.KMC_MODELS object the viewer reads from at show() time. Under 'loading' the stage
       shows the product photo instead of an empty canvas. */
    var viewerReady = null, modelUrls = {}, modelLoads = {};
    try { modelUrls = JSON.parse(root.dataset.models || '{}'); } catch (e) {}

    function ensureViewer() {
      if (!stage || !canvas) return Promise.resolve();
      if (viewerTried) return viewerReady;
      viewerTried = true;
      window.KMC_MODELS = window.KMC_MODELS || {};
      viewerReady = load(root.dataset.viewerSrc)
        .then(function () {
          if (root.dataset.modelsSrc) return load(root.dataset.modelsSrc); /* legacy single bundle */
        })
        .then(function () {
          if (window.KMCViewer) viewer = window.KMCViewer(canvas, window.KMC_MODELS);
          if (!viewer) stage.classList.add('nogl');
        })
        .catch(function () { stage.classList.add('nogl'); });
      return viewerReady;
    }
    function ensureModel(key) {
      if (!key || !modelUrls[key]) return Promise.resolve();
      if (!modelLoads[key]) {
        modelLoads[key] = load(modelUrls[key]).catch(function () { delete modelLoads[key]; });
      }
      return modelLoads[key];
    }

    tiles.forEach(function (t) {
      t.addEventListener('click', function () {
        var d = DATA[t.dataset.handle];
        if (!d) return;
        tiles.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        t.setAttribute('aria-pressed', 'true');
        current = d;
        if (nameEl) nameEl.textContent = d.title;
        if (fitEl) fitEl.textContent = d.fit || '';
        if (form) { form.classList.add('on'); form.setAttribute('aria-disabled', 'false'); }
        selectVariant(pickVariant(null));
        buildSwatches();
        if (fallback && d.image) fallback.src = d.image;
        if (moreEl) { moreEl.href = d.url || ''; moreEl.hidden = !d.url; }
        if (stage) {
          stage.classList.add('loading');
          Promise.all([ensureViewer(), ensureModel(d.model)]).then(function () {
            if (current !== d) return;                 /* they picked another can meanwhile */
            stage.classList.remove('loading');
            if (viewer && d.model && viewer.show(d.model)) {
              stage.classList.remove('nogl');
              if (variant && variant.colour) viewer.colour(variant.colour);
            } else {
              stage.classList.add('nogl');             /* no WebGL or no mesh: show the photo */
            }
          });
        }
        paintFitWarning();
        if (window.innerWidth < 820 && form) form.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });

    if (stage) stage.addEventListener('pointerdown', function () { stage.classList.add('touched'); }, { once: true });

    if (form) form.addEventListener('submit', function (e) {
      if (!variant || !variant.available) { e.preventDefault(); return; }
      if (!window.fetch) return;                     /* no fetch: let the browser post the form */
      e.preventDefault();
      /* No lock and no timer: the button stays live, the adds queue up behind each other, and
         the product flies to the cart icon. Stay on the page everywhere. */
      var v = variant, d = current;
      setErr('');
      flashAdded(addBtn, restoreAddBtn);
      var landed = flyToCart(d.image || (fallback && fallback.src), rectOf(stage) || addBtn.getBoundingClientRect());
      addToCart(v.id, 1).then(function () {
        if (!canFly) toast('Added: ' + d.title + ', ' + (v.colour || '').toLowerCase());
        return landed;
      }).then(nudge).catch(function (err) {
        clearTimeout(addBtn._kmcT);
        restoreAddBtn();
        setErr((err && err.description) ? err.description : 'Could not add that to the cart.');
      });
    });

    /* Sticky bar on phones. It is a checkout bar, not a second add-to-cart: the page already has
       an Add to cart button, so duplicating it was just taking up room. It stays out of the way
       until there is something in the cart, then it shows what is in there and goes to the cart. */
    if (root.dataset.sticky === 'true' && !document.querySelector('.kmc-sticky')) {
      var barHost = document.createElement('div');
      barHost.className = 'kmc-nr';
      var bar = document.createElement('div');
      bar.className = 'sticky kmc-sticky';
      bar.hidden = true;
      bar.innerHTML = '<div class="s-txt"><small></small><b></b></div>' +
                      '<a class="btn btn-red btn-sm" href="' +
                      ((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart') +
                      '">Checkout</a>';
      barHost.appendChild(bar);
      document.body.appendChild(barHost);
      var sSmall = bar.querySelector('small'),
          sBig   = bar.querySelector('b');

      function paintSticky(cart) {
        var n = cart ? cart.item_count : 0;
        if (!n) {
          bar.hidden = true;
          document.documentElement.classList.remove('kmc-has-sticky');
          return;
        }
        sSmall.textContent = 'In your cart';
        sBig.textContent = n === 1 ? '1 item' : n + ' items';
        bar.hidden = false;
        document.documentElement.classList.add('kmc-has-sticky');
      }
      document.addEventListener('kmc:cart', function (e) { paintSticky(e.detail.cart); });
      if (lastCart) paintSticky(lastCart);
      else refreshCartCount().catch(function () {});
    }
  }

  /* ---------- boot ---------- */
  function boot(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-kmc-picker]').forEach(initPicker);
    bindQuickAdd(scope);
    bindHero(scope);
    bindReel(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  window.KMCNight = { toast: toast, addToCart: addToCart, refreshCartCount: refreshCartCount, enqueue: enqueue, flyToCart: flyToCart };
})();
